import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { brl } from "@/lib/format";
import { Trash2, Plus, Minus, ShoppingBag } from "lucide-react";

export default function Cart() {
  const { items, update, remove, subtotal } = useCart();
  const nav = useNavigate();
  const threshold = 199;
  const progress = Math.min(100, (subtotal/threshold)*100);

  if (items.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        <ShoppingBag className="w-16 h-16 text-[#E8A0B4] mx-auto mb-4" />
        <h2 className="font-serif text-3xl text-[#4A3B40]">Seu carrinho está vazio</h2>
        <p className="text-[#8C7A80] mt-2">Que tal explorar nossos acessórios?</p>
        <Link to="/" className="btn-lara mt-6 inline-flex">Voltar à loja</Link>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h1 className="font-serif text-3xl text-[#4A3B40] mb-6">Carrinho</h1>
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-2xl border border-[#F9E1E8] p-4">
          {subtotal < threshold ? (
            <div className="mb-4 bg-[#F9E1E8]/50 rounded-xl p-3">
              <p className="text-sm text-[#4A3B40]">Faltam <strong className="text-[#C9708B]">{brl(threshold - subtotal)}</strong> para o frete grátis!</p>
              <div className="w-full bg-white rounded-full h-2 overflow-hidden mt-2">
                <div className="bg-[#E8A0B4] h-full" style={{width: `${progress}%`}} />
              </div>
            </div>
          ) : <p className="text-[#7DBE9E] font-semibold mb-4">🎉 Frete grátis desbloqueado!</p>}
          {items.map((it, idx) => {
            const price = it.product.promo_price || it.product.price;
            return (
              <div key={idx} className="flex gap-4 py-4 border-b border-[#F9E1E8] last:border-0" data-testid={`cart-page-item-${idx}`}>
                <img src={(it.product.images||[])[0] || "https://placehold.co/120x120/F9E1E8/C9708B?text=L"} alt="" className="w-24 h-24 rounded-xl object-cover bg-[#FFF9FA]" />
                <div className="flex-1">
                  <Link to={`/produto/${it.product.slug}`} className="font-serif font-medium text-[#4A3B40] hover:text-[#C9708B]">{it.product.name}</Link>
                  <p className="text-[#C9708B] font-bold mt-1">{brl(price)}</p>
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center border border-[#F9E1E8] rounded-full">
                      <button onClick={() => update(idx, it.quantity-1)} className="w-8 h-8"><Minus className="w-3 h-3 mx-auto text-[#C9708B]" /></button>
                      <span className="w-8 text-center text-sm">{it.quantity}</span>
                      <button onClick={() => update(idx, it.quantity+1)} className="w-8 h-8"><Plus className="w-3 h-3 mx-auto text-[#C9708B]" /></button>
                    </div>
                    <div className="text-right">
                      <p className="text-sm text-[#8C7A80]">Subtotal</p>
                      <p className="font-semibold">{brl(price * it.quantity)}</p>
                    </div>
                    <button onClick={() => remove(idx)} className="text-[#E57373]"><Trash2 className="w-5 h-5" /></button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <aside className="bg-white rounded-2xl border border-[#F9E1E8] p-5 h-fit sticky top-24">
          <h3 className="font-serif text-lg text-[#4A3B40] mb-4">Resumo</h3>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-[#8C7A80]">Subtotal</span><span>{brl(subtotal)}</span></div>
            <div className="flex justify-between"><span className="text-[#8C7A80]">Frete</span><span className="text-[#8C7A80]">Calcular no checkout</span></div>
            <div className="flex justify-between border-t border-[#F9E1E8] pt-2 mt-2 text-base"><span className="font-bold">Total</span><span className="font-bold text-[#C9708B]">{brl(subtotal)}</span></div>
          </div>
          <button onClick={() => nav("/checkout")} className="w-full btn-lara mt-5" data-testid="cart-page-checkout">Finalizar compra</button>
          <Link to="/" className="block text-center text-sm text-[#C9708B] font-semibold mt-3 hover:underline">Continuar comprando</Link>
        </aside>
      </div>
    </div>
  );
}
